/**
 * Initialize payment response DTO
 */
export class InitializePaymentResponseDto {
	token!: string;
	redirectUrl!: string;
	expiration?: string;
}
